import { Component, Input, OnChanges, SimpleChanges, OnInit } from '@angular/core';

import { IDashBoardAdminChartDetailsWithProvider } from '../dasboard-admin-chart-details.model';
import { ChartValue } from '../chart/chart-value.model';
import { DateHelperService } from '../../core/services';
import { LineChartOptions } from "../chart/line-chart-options.model";
import { IPublisher } from "../../shared/publisher.model";
import { WebWorkerService } from "angular2-web-worker/web-worker.service";

@Component({
    moduleId: module.id,
    selector: 'played-view',
    templateUrl: 'played-view.component.html'
})

export class PlayedViewComponent implements OnInit, OnChanges {
    @Input() data: IDashBoardAdminChartDetailsWithProvider;
    @Input() dataForToday: IDashBoardAdminChartDetailsWithProvider;
    @Input() period: string;
    @Input() showTopSectionOverlay: boolean;
    chartValues: ChartValue[];
    triggerChange: Date;
    chartOptions: LineChartOptions = new LineChartOptions();
    toolTipText: string = "{2} {0} {1} ";

    constructor(private dateHelper: DateHelperService,
        private webWorkerService: WebWorkerService) {
    }

    ngOnInit() {
        this.chartOptions.formatTooltip = '1.0';
    }

    private mapAllData(): void {
        this.chartValues = new Array<ChartValue>();
        let publishers: IPublisher[] = new Array<IPublisher>();
        for (let item of this.data.playedViews) {
            if (publishers.findIndex(s => s.id == item.publisher.id) === -1)
                publishers.push(item.publisher);
        }
        if (publishers.length > 0) {
            for (let publisher of publishers) {
                let chartValue = new ChartValue(publisher.name);
                chartValue.identifier = publisher.id;
                let played = this.data.playedViews.filter(x => x.publisher.id == publisher.id);
                for (let item of played) {
                    chartValue.data.push([this.dateHelper.getTicks(item.played.dateUtc), item.played.count]);
                    chartValue.lastItemIdentifier = item.played.dateUtc;
                }
                this.chartValues.push(chartValue);
            }
        }
    }

    private mapTodayData(params: any): void {
        Array.prototype.findIndex || Object.defineProperty(Array.prototype, "findIndex", { value: function (r) { if (null == this) throw new TypeError('"this" is null or not defined'); var e = Object(this), t = e.length >>> 0; if ("function" != typeof r) throw new TypeError("predicate must be a function"); for (var n = arguments[1], o = 0; o < t;) { var i = e[o]; if (r.call(n, i, o, e)) return o; o++ } return -1 } }), Array.prototype.find || Object.defineProperty(Array.prototype, "find", { value: function (r) { if (null == this) throw new TypeError('"this" is null or not defined'); var e = Object(this), t = e.length >>> 0; if ("function" != typeof r) throw new TypeError("predicate must be a function"); for (var n = arguments[1], o = 0; o < t;) { var i = e[o]; if (r.call(n, i, o, e)) return i; o++ } } });
        let publishers = new Array();
        for (let item of params.dataForToday.playedViews) {
            if (publishers.findIndex(s => s.id == item.publisher.id) === -1)
                publishers.push(item.publisher);
        }
        if (publishers.length > 0) {
            for (let publisher of publishers) {
                let chartValue = params.chartValues.find(x => x.identifier == publisher.id);
                if (chartValue) {
                    let lastValue = chartValue.data[chartValue.data.length - 1];
                    let playedViews = params.dataForToday.playedViews.filter(x => x.publisher.id == publisher.id);
                    for (let item of playedViews) {
                        if (formatDate(item.played.dateUtc) == formatDate(chartValue.lastItemIdentifier)) {
                            lastValue[1] = item.played.count;
                        }
                    }
                }
            }
        }
        function formatDate(date: Date) {
            let _date = new Date(date);
            let day = _date.getDate();
            let monthIndex = _date.getMonth();
            let year = _date.getFullYear();
            return year + '-' + monthIndex + '-' + day;
        }
        return params;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.data && changes["data"] && changes["data"].previousValue != changes["data"].currentValue)
            this.mapAllData();
        if (this.dataForToday) {
            let params = {
                dataForToday: this.dataForToday,
                chartValues: this.chartValues
            }
            if (typeof (Worker) !== "undefined") {
                this.webWorkerService.run(this.mapTodayData, params).then((res) => {
                    this.onMapTodayData(res);
                }).catch((r) => { console.log(r) });
            } else {
                let res = this.mapTodayData(params);
                this.onMapTodayData(res);
            }
        }
    }

    private onMapTodayData(res: any) {
        this.dataForToday = res.dataForToday;
        this.chartValues = res.chartValues;
        this.triggerChange = new Date();
    }
}


// WEBPACK FOOTER //
// ./src/app/dashboard/playedview/played-view.component.ts